import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { v4 as uuidv4 } from 'uuid';
import Logger from '../services/Logger';
import ModuleTypeEnum from '../enums/ModuleType.enum';
var logger = new Logger('core.PluginManager');

var PluginManager = /*#__PURE__*/function () {
  function PluginManager() {
    _classCallCheck(this, PluginManager);

    this._plugins = [];
  }

  _createClass(PluginManager, [{
    key: "registerPlugin",
    value: function registerPlugin(plugin) {
      if (!plugin) {
        logger.warn('Invalid plugin passed to register');
        return;
      }

      var pluginId = plugin.id || uuidv4();

      if (this._plugins.some(function (p) {
        return p.id === pluginId;
      })) {
        logger.warn("Duplicate plugin with plugin id ".concat(pluginId));
        return;
      } // Call onPreRegistration hook


      if (plugin.onPreRegisteration) {
        plugin.onPreRegisteration();
      }

      var modules = [];
      Object.keys(ModuleTypeEnum).forEach(function (moduleTypeName) {
        modules[moduleTypeName] = plugin[moduleTypeName];
      }); // Register the plugin

      this._plugins.push({
        id: plugin.id,
        path: plugin.path,
        name: plugin.name,
        modules: modules
      });
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "plugins",
    get: function get() {
      return this._plugins;
    }
  }]);

  return PluginManager;
}(); // Singleton Plugin Manager


var pluginManager = new PluginManager();
var _default = pluginManager;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/PluginManager.js");
  reactHotLoader.register(PluginManager, "PluginManager", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/PluginManager.js");
  reactHotLoader.register(pluginManager, "pluginManager", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/PluginManager.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/managers/PluginManager.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();